import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const stats = [{
  value: '+500',
  label: 'kinesiólogos confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '+10',
  label: 'editables prácticos'
}];
const testimonials = [{
  initials: 'LP',
  quote: '"Organicé todo mi consultorio en una tarde. Tengo cada sesión planificada, con el protocolo listo y el informe para entregar. Nunca más improviso."',
  author: '— Laura P., Buenos Aires | Kinesióloga en Consultorio Privado'
}, {
  initials: 'MC',
  quote: '"Los protocolos de evaluación me salvaron. Ahora llego preparado, el paciente se va con todo y me percibe como un profesional de otro nivel."',
  author: '— Martín C., Rosario | Kinesiólogo Clínico — Centro de Rehabilitación'
}, {
  initials: 'SV',
  quote: '"Antes armaba cada informe desde cero y tardaba 2 horas. Ahora lo resuelvo en 10 minutos y cobro el doble porque mi sesión tiene otro peso."',
  author: '— Sofía V., Córdoba | Kinesióloga Independiente'
}];
export function SocialProof() {
  useTrackSection('social-proof', 'Social Proof Section');
  return <section id="social-proof" className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(235,248,255) 0%, rgb(224,247,255) 15%, rgb(224,247,255) 85%, rgb(248,250,252) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-282">
      <div className="mx-auto max-w-4xl" data-id="element-283">
        {/* Stats Grid */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-284">
          {stats.map(stat => <div key={stat.label} data-id="element-285">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-286">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold" style={{
            color: '#0077B6'
          }} data-id="element-287">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-288">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white rounded-lg p-3 shadow-sm" style={{
          border: '1px solid rgba(0,119,182,0.20)'
        }} data-id="element-289">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center text-xs font-black rounded-full" style={{
            backgroundColor: 'rgba(0,119,182,0.10)',
            color: '#0077B6'
          }} data-id="element-290">
                {t.initials}
              </div>
              <div data-id="element-291">
                <div className="mb-1 text-[10px]" style={{
              color: '#0077B6'
            }} data-id="element-292">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-293">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-294">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}